/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Options/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Create from './Create/index'
import Edit from './Edit/index'
import React from 'react'
import ThreeDotsMenu from 'DesignSystem/ThreeDotsMenu/index'



/** @type {import('Simple/types.js').View} */
export default function Options({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/Carrier/Content/Options"
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ThreeDotsMenu
  viewPath={`${viewPath}/ThreeDotsMenu`}
 data="options"
 from={optionsValueData}
 onClick={onClick}
 width="auto"
 height="auto"
 alignSelf="center"
/>
<Create
  viewPath={`${viewPath}/Create`}
/>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
{children}
</React.Fragment>)
}